module.exports = __webpack_public_path__ + "img/plant-2.e4083ab.png";